import { CalendarIcon } from '@chakra-ui/icons'
import { Input, InputGroup, InputProps, InputRightElement } from '@chakra-ui/react'
import React, { MouseEventHandler, useRef } from 'react'
import DatePicker, { DateObject } from 'react-multi-date-picker'

type Props = InputProps & {
  onDatePickerChange: (from: DateObject | null, to: DateObject | null) => void
}

const RangeDatePicker = React.forwardRef<HTMLInputElement, Props>(
  ({ onDatePickerChange, ...props }, ref) => {
    const datePickerRef = useRef<React.ElementRef<typeof DatePicker>>(null)

    return (
      <DatePicker
        range
        arrow={false}
        className="gray"
        ref={datePickerRef}
        onChange={(dateObjects: DateObject[] = []) => {
          const from = dateObjects[0] || null
          const to = dateObjects[1] || null
          onDatePickerChange(from, to)

          if (from && to) {
            datePickerRef.current?.closeCalendar()
          }
        }}
        render={(
          value: string[],
          openCalendar: MouseEventHandler<SVGElement | HTMLInputElement>,
        ) => {
          const displayValue =
            value?.[0] && value?.[1]
              ? `${value[0]} - ${value[1]}`
              : value?.[0]
              ? `${value[0]} -`
              : ''

          return (
            <InputGroup size="lg">
              <Input
                placeholder="Select period"
                ref={ref}
                value={displayValue}
                readOnly
                autoComplete="off"
                onClick={openCalendar}
                {...props}
              />
              <InputRightElement>
                <CalendarIcon color="gray" onClick={openCalendar} />
              </InputRightElement>
            </InputGroup>
          )
        }}
      />
    )
  },
)

export default RangeDatePicker
